import styled from 'styled-components'
import { ReactComponent as QuestionIcon } from 'assets/img/question-icon.svg'
import { GRAY4, PRIMARY_TEXT } from 'constants/colors'

export const StyledQuestionIcon = styled(QuestionIcon)`
  margin-left: 10px;
`

export const ParametersContainer = styled.div`
  border-radius: 8px;
  background: ${GRAY4};
  padding: 16px;

  .MuiFormControlLabel-root {
    margin: 0;

    span[aria-label='checkbox'] {
      margin-right: 10px;
    }
  }

  .MuiFormControl-root {
    margin: 10px 0;
  }
`

export const ParametersHeader = styled.div`
  color: ${PRIMARY_TEXT};
  font-size: 16px;
  line-height: 140%;
  margin-bottom: 10px;
`

export const CheckboxContainer = styled.div`
  margin: 10px 0 20px 0;
`
export const DueDateSettingsLabel = styled.div`
  padding: 30px 20px 0;
`
export const DueDateDaysWrapper = styled.div`
  .MuiInputBase-root {
    width: 50px;
  }
  .MuiInput-root .MuiInput-input {
    padding-top: 8px;
    padding-bottom: 3px;
    text-align: center;
  }
`
export const TimePickerWrapper = styled.div`
  .MuiInputBase-root {
    width: 110px;
  }
  .MuiInput-root .MuiInput-input {
    padding-top: 18px;
    padding-bottom: 3px;
  }
`
